import { ReactNode } from 'react';
import { ROUTES } from 'src/constants/routes';
import useGoToPreviousPageIfDataMissing from 'src/helpers/hooks/useGoToPreviousPageIfDataMissing';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';

interface PurchaseFlowMissingDataGuardProps {
  children: ReactNode;
  /** The current route to check the data */
  currentRoute: (typeof ROUTES)[keyof typeof ROUTES];
  /** If true, the search params will be ignored for checking the data. `false` by default. */
  ingoreSearchParams?: boolean;
}

/**
 * This component will check if the data is missing for the current route and will redirect to the previous page if so.
 */
export function PurchaseFlowMissingDataGuard({
  children,
  currentRoute,
  ingoreSearchParams = false,
}: PurchaseFlowMissingDataGuardProps) {
  const getUrlWithSearchParams = useLocationSearch();
  const currentRouteWithSearchParams = getUrlWithSearchParams(currentRoute);
  const usedRoute = ingoreSearchParams
    ? currentRoute
    : currentRouteWithSearchParams;

  useGoToPreviousPageIfDataMissing(usedRoute);
  return <>{children}</>;
}
